import React from 'react';
import './_Divider.scss';

Divider.defaultProps = {
    invisible: false,
};

function Divider(props) {
    let mod_class = [
        'Divider',
        props.spacing !== undefined ? 'spacing-' + props.spacing : '',
        props.theme !== undefined ? 'theme-' + props.theme : '',
        props.invisible === true ? 'is-invisible' : '',
    ];
    mod_class = mod_class.join(' ');

    return <span className={mod_class}></span>;
}

export default Divider;
